import { useQuery } from '@tanstack/react-query';
import { apiFetchSettings } from '../../settings/api';
import { SettingKey } from '../../../models/Settings';

export const useAmberSearchGlobalUrl = () => {
  return useQuery({
    queryKey: ['amberSearchGlobalUrl'],
    queryFn: async () => {
      const { data } = await apiFetchSettings([
        {
          keys: ['ProjectExtension_AmberSearch_GlobalUrl'],
          eSettingScope: 'global',
        } as SettingKey,
      ]);
      const parsed = JSON.parse(data?.[0]?.jsonValue || '{}');
      //TODO: Entfernen wenn nicht mehr benötigt, da die Einstellung in CamelCase umbenannt wurde
      const globalUrl =
        (parsed?.globalUrl ?? parsed?.GlobalUrl)?.trim() || '';
      return globalUrl;
    },
  });
};
